/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeRule.defs.js'
export * as $defs from './removeRule.defs.js'
